<div class="service-section container-fluid">

  <div class="alert alert-danger alert-dismissible fade show" *ngIf="errorMessage" role="alert">
    <mat-icon>error</mat-icon>
    <span class="ms-2">{{ errorMessage }}</span>
    <button type="button" class="btn-close" (click)="clearError()"></button>
  </div>

  <div class="section-header mb-4">
    <div class="row">
      <div class="col-md-12">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h6 class="fw-bold mb-1">Conceptos disponibles para reserva</h6>
            <p class="text-muted mb-0">Gestiona los conceptos y personal asignado de este centro de trabajo</p>
          </div>
          <div class="d-flex gap-2">
            <app-button
              label="Añadir varios"
              icon="playlist_add"
              variant="primary"
              (click)="openBulkAddDialog()">
            </app-button>
            <app-button
              label="Añadir concepto"
              icon="add"
              variant="primary"
              (click)="openServiceDialog()">
            </app-button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-5">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Buscar concepto</mat-label>
          <input matInput 
                 [value]="searchTerm" 
                 (input)="onSearchChange($event.target.value)" 
                 placeholder="Buscar por título o descripción...">
          <mat-icon matPrefix>search</mat-icon>
          <mat-icon matSuffix class="cf-spin-icon" *ngIf="isLoading">autorenew</mat-icon>
        </mat-form-field>
      </div>
      <div class="col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Estado</mat-label>
          <mat-select [value]="filterStatus" (selectionChange)="onStatusFilterChange($event.value)">
            <mat-option [value]="null">Todos los estados</mat-option>
            <mat-option *ngFor="let status of conceptStatuses; trackBy: trackByIndex" [value]="status.statusMerchantConceptId">
              {{ status.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-4 d-flex align-items-center justify-content-end">
        <span class="text-muted">
          <strong>{{ totalItems }}</strong> concepto{{ totalItems !== 1 ? 's' : '' }} total{{ totalItems !== 1 ? 'es' : '' }}
        </span>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading && concepts.length === 0" class="loading-state text-center py-5">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
    <p class="text-muted">Cargando conceptos...</p>
  </div>

  <div *ngIf="!isLoading || concepts.length > 0" class="services-content">
    <div *ngIf="concepts.length > 0; else emptyState" class="services-table-container">
      <table class="services-table">
        <thead>
          <tr>
            <th class="text-center drag-handle-col" matTooltip="Arrastra para reordenar"></th>
            <th>Título</th>
            <th>Descripción</th>
            <th class="text-center">Duración</th>
            <th class="text-end">Precio</th>
            <th class="text-center" matTooltip="Tiempo reservado antes / después del servicio">Márgenes</th>
            <th class="text-center">Estado</th>
            <th class="text-center">Staff</th>
            <th class="text-center">Acciones</th>
          </tr>
        </thead>
        <tbody cdkDropList (cdkDropListDropped)="onConceptDrop($event)">
          <tr *ngFor="let concept of concepts; trackBy: trackByIndex" class="service-row" cdkDrag cdkDragLockAxis="y">
            <td class="text-center drag-handle" cdkDragHandle>
              <mat-icon>drag_handle</mat-icon>
            </td>
            <td>
              <div class="concept-info">
                <mat-icon class="concept-icon">store</mat-icon>
                <span class="concept-name">{{ concept.title }}</span>
              </div>
            </td>
            <td>
              <span class="concept-description">{{ concept.description || '-' }}</span>
            </td>
            <td class="text-center">
              <span class="duration-badge">{{ concept.durationMinutes }} min</span>
            </td>
            <td class="text-end">
              <span class="price-text">{{ concept.price | number:'1.2-2' }}€</span>
            </td>
            <td class="text-center">
              <span class="buffer-text">{{ concept.bufferBeforeMinutes }} / {{ concept.bufferAfterMinutes }}</span>
            </td>
            <td class="text-center">
              <span class="status-badge" 
                    [class.status-active]="concept.statusMerchantConceptId === 1" 
                    [class.status-inactive]="concept.statusMerchantConceptId === 2"
                    [class.status-archived]="concept.statusMerchantConceptId === 3">
                {{ concept.statusName }}
              </span>
            </td>
            <td class="text-center">
              <span class="staff-count" *ngIf="concept.staffCount > 0">
                <mat-icon class="small-icon">people</mat-icon>
                {{ concept.staffCount }}
              </span>
              <span class="text-muted" *ngIf="concept.staffCount === 0">
                Sin asignar
              </span>
            </td>
            <td class="text-center">
              <div class="action-buttons">
                <button mat-icon-button matTooltip="Editar" (click)="openServiceDialog(concept)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button matTooltip="Eliminar" color="warn" (click)="confirmDelete(concept)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="pagination-container mt-4" *ngIf="totalPages > 1">
        <div class="d-flex justify-content-between align-items-center">
          <div class="pagination-info">
            Página {{ currentPage }} de {{ totalPages }}
          </div>
          <div class="pagination-controls d-flex gap-2">
            <button mat-icon-button 
                    [disabled]="currentPage === 1 || isLoading" 
                    (click)="previousPage()"
                    matTooltip="Página anterior">
              <mat-icon>chevron_left</mat-icon>
            </button>
            
            <button mat-button 
                    *ngFor="let page of [].constructor(totalPages); let i = index; trackBy: trackByIndex"
                    [class.active]="currentPage === i + 1"
                    [disabled]="isLoading"
                    (click)="goToPage(i + 1)">
              {{ i + 1 }}
            </button>
            
            <button mat-icon-button 
                    [disabled]="currentPage === totalPages || isLoading" 
                    (click)="nextPage()"
                    matTooltip="Página siguiente">
              <mat-icon>chevron_right</mat-icon>
            </button>
          </div>
          <div class="pagination-size">
            {{ pageSize }} por página
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #emptyState>
    <div class="empty-state">
      <mat-icon>store</mat-icon>
      <h5>No hay conceptos configurados</h5>
      <p class="text-muted">Añade los conceptos que estarán disponibles para reserva en este centro de trabajo</p>
      <div class="empty-actions">
        <app-button
          label="Añadir varios conceptos"
          icon="playlist_add"
          variant="primary"
          (click)="openBulkAddDialog()">
        </app-button>
        <app-button 
          label="Añadir primer concepto" 
          icon="add" 
          variant="primary" 
          (click)="openServiceDialog()">
        </app-button>
      </div>
    </div>
  </ng-template>

</div>
